import { render } from "./InnovationRadarChart.vue?vue&type=template&id=b8089aca&scoped=true"
import script from "./InnovationRadarChart.vue?vue&type=script&lang=js"
export * from "./InnovationRadarChart.vue?vue&type=script&lang=js"

import "./InnovationRadarChart.vue?vue&type=style&index=0&id=b8089aca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8089aca"]])

export default __exports__